import React from "react"
import { Box, Text, Flex } from "theme-ui"
import SectionHeader from "./SectionHeader"

interface ContentSectionProps {
  headingElement?: React.ReactNode
  header?: string
  subHeader?: string
  body: React.ReactNode
  noHeaderBorder: boolean
}

const ContentSection = (props: ContentSectionProps) => {
  const { header, body, subHeader, noHeaderBorder, headingElement } = props
  const isSubHeaderPresent = Boolean(subHeader)

  return (
    <Flex sx={{ flexDirection: "column" }} px={[3, 5]} pt={[3, 4]} my={[1,5]}>
      {headingElement || (
        <SectionHeader noBorder={noHeaderBorder}>{header}</SectionHeader>
      )}
      {isSubHeaderPresent && (
        <Text sx={{ textAlign: "center" }} variant="secondary">
          Eminent personalities who are experts in their domain are the guest
          lecturers
        </Text>
      )}
      <Box mt={isSubHeaderPresent ? 4 : 5}>{body}</Box>
    </Flex>
  )
}

ContentSection.defaultProps = {
  noHeaderBorder: false,
  subHeader: "",
}

export default ContentSection
